'use client';

import { FC, SVGProps } from 'react';

const IconFeatureUnified: FC<SVGProps<SVGSVGElement>> = ({ ...props }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
      <path d="M9 16.4004C12.866 16.4004 16 13.2664 16 9.40039C16 5.5344 12.866 2.40039 9 2.40039C5.13401 2.40039 2 5.5344 2 9.40039C2 13.2664 5.13401 16.4004 9 16.4004Z" stroke="#7C8088" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M15 22.4004C18.866 22.4004 22 19.2664 22 15.4004C22 11.5344 18.866 8.40039 15 8.40039C11.134 8.40039 8 11.5344 8 15.4004C8 19.2664 11.134 22.4004 15 22.4004Z" stroke="#7C8088" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default IconFeatureUnified;
